import { useState } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppText } from 'shared/UI/UIKit/Text';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import { removeRegionAction } from 'features/regions/redux/actions';
import type { RemoveRegionModalProps } from './types';
import { RegionModalFooter } from '../ModalFooter';
import styles from './Remove.module.scss';

export const RemoveRegionModal = (props: RemoveRegionModalProps) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { selectedRegion } = useAppSelector((state) => state.regionsState);

  const confirm = () => {
    if (!selectedRegion) return;

    setLoading(true);
    dispatch(removeRegionAction(selectedRegion.id))
      .unwrap()
      .then(() => {
        props.onItemRemove();
        props.hide();
      })
      .finally(() => setLoading(false));
  };

  const footer = <RegionModalFooter onSubmit={confirm} hideModal={props.hide} title="Удалить" />;

  const content = (
    <AppFlex unit="8" className={styles.content}>
      <AppText size={16} type="secondary">
        Подтвердите удаление региона
      </AppText>
      <AppText size={18}>{selectedRegion?.name || ''}</AppText>
    </AppFlex>
  );

  return (
    <AppModal
      visible={props.visible}
      onCancel={props.hide}
      size="auto"
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Удаление региона"
      maskClosable={false}
    />
  );
};
